'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.monthsUntil;


// WEBPACK FOOTER //
// ./~/sugar-date/date/monthsUntil.js